module.exports = __webpack_public_path__ + "img/WABI.d3734f69.svg";